import { createContext } from 'react';

import { TokenStorage } from '../commonTypes';

export type RequestGatewayContextType = {
  isProtectedRoute: boolean;
  baseUrl: string;
  version?: string;
  source?: string;
  tokenStorage?: TokenStorage;
  refreshTokenUrl: string;
};

export const RequestGatewayContext = createContext<RequestGatewayContextType>({
  isProtectedRoute: false,
  baseUrl: '',
  refreshTokenUrl: '',
});
